export var OrderizableTypes;
(function (OrderizableTypes) {
    OrderizableTypes["APPOINTMENT"] = "appointment";
    OrderizableTypes["ADDON_SERVICE"] = "addon_service";
    OrderizableTypes["PRODUCT"] = "product";
    OrderizableTypes["MEMBERSHIP"] = "membership";
    OrderizableTypes["CUSTOM"] = "custom";
})(OrderizableTypes || (OrderizableTypes = {}));
export var RedeemTypes;
(function (RedeemTypes) {
    RedeemTypes["ENROLLMENT"] = "enrollment";
})(RedeemTypes || (RedeemTypes = {}));
